import React, { useEffect } from 'react';

interface WithTabTitleProps {
  title: string;
  children: React.ReactElement;
}

export const WithTabTitle = (props: WithTabTitleProps) => {
  useEffect(() => {
    document.title = props.title;
  }, [props.title]);
  return props.children;
};
